import { ExpressionFunctions } from "./xmlConfig";
import { DateTime } from "luxon";
import { template } from "lodash";
export const galileoXMLConfig = require("./galileo_config.json");
export const focusXMLConfig = require("./focus_config.json");
export const getValue = (item, key) => {
    if (key in item) {
        return item[key];
    }
    else {
        return null;
    }
};
const getTimeTranform = (from) => {
    switch (from) {
        case "iso":
            return x => DateTime.fromISO(x).toUTC();
        case "millis":
        default:
            return x => DateTime.fromMillis(x).toUTC();
    }
};
export const evaluateExpression = (item, expression) => {
    switch (expression.type) {
        case ExpressionFunctions.Time:
            const value = getValue(item, expression.key);
            const transform = getTimeTranform(expression.from);
            return transform(value).toFormat(expression.to);
        case ExpressionFunctions.Template:
            const compiled = template(expression.to);
            return compiled(item);
        case ExpressionFunctions.Constant:
            return expression.to;
        case ExpressionFunctions.Conditional:
            const maybeValue = evaluateItem(item, expression.value);
            const enableVariable = getValue(item, expression.key);
            const isvalid = expression.oneOf.includes(enableVariable);
            return isvalid ? maybeValue : null;
        case ExpressionFunctions.Translate:
            const original_value = getValue(item, expression.key);
            const index = expression.from.findIndex(key => key === original_value);
            if (index > -1) {
                return expression.to[index];
            }
            else {
                return original_value;
            }
        default:
            return "";
    }
};
export const evaluateItem = (item, expression) => {
    if (typeof expression === "string") {
        return getValue(item, expression);
    }
    else {
        return evaluateExpression(item, expression);
    }
};
const createItemDoc = (item, config, xmlDoc) => {
    const newDoc = xmlDoc.createElement(config.name);
    if (config.attributes) {
        config.attributes.forEach(attribute => {
            const value = evaluateItem(item, attribute.value);
            newDoc.setAttribute(attribute.name, value);
        });
    }
    if ("value" in config) {
        const value = evaluateItem(item, config.value);
        if ((value === "" || value === null) && config.optional) {
            return null;
        }
        newDoc.innerHTML = value;
    }
    else {
        config.children.forEach(child => {
            const childElement = createItemDoc(item, child, xmlDoc);
            childElement && newDoc.appendChild(childElement);
        });
    }
    return newDoc;
};
export const createXML = (items, config) => {
    var xmlDoc = document.implementation.createDocument("", "", null);
    const root = xmlDoc.createElement(config.root);
    for (const item of items) {
        const itemDoc = createItemDoc(item, config.items, xmlDoc);
        root.appendChild(itemDoc);
    }
    xmlDoc.appendChild(root);
    var serializer = new XMLSerializer();
    var xmlString = serializer.serializeToString(xmlDoc);
    return `<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n${xmlString}`;
};
//# sourceMappingURL=index.js.map